const storageKey = (enrollmentId: number): string =>
	`app2-announcement-video-time-${enrollmentId}`;

/** Best-effort local resume when assigned API has not returned videoTime yet. */
export const readStoredAnnouncementVideoTime = (enrollmentId: number): number | undefined => {
	try {
		const raw = sessionStorage.getItem(storageKey(enrollmentId));
		if (raw == null) {
			return undefined;
		}
		const seconds = Number(raw);
		if (!Number.isFinite(seconds) || seconds <= 0) {
			return undefined;
		}
		return Math.round(seconds);
	} catch {
		return undefined;
	}
};

export const writeStoredAnnouncementVideoTime = (enrollmentId: number, seconds: number): void => {
	try {
		if (!Number.isFinite(seconds) || seconds <= 0) {
			return;
		}
		sessionStorage.setItem(storageKey(enrollmentId), String(Math.round(seconds)));
	} catch {
		// ignore quota / private mode
	}
};
